/* eslint-disable max-len */
/* eslint-disable no-console */
import { Box, Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import React, { useContext } from 'react';
import { visuallyHidden } from '@mui/utils';
import { LanguageContext } from '../../../../../../libs/Context';
import { MediaContext } from '../../../..';
import { useParams } from 'react-router-dom';

const MediaKitTableHead = (props) =>
{
	const { visibleFolderData } = props;
	const { language } = useContext(LanguageContext);
	const { mediaState, setMediaState, tab } = useContext(MediaContext);
	const id = useParams()?.userId;

	const handleSelectAll = (event:any) =>
	{
		if (event.target.checked)
		{
			setMediaState({ type: 'updateReducer', payload: { selectedData: visibleFolderData, allSelected: true } });
		}
		else
		{
			setMediaState({ type: 'updateReducer', payload: { selectedData: [], allSelected: false } });
		}
	};

	const toggleSortByName = () =>
	{
		setMediaState({ type: 'updateReducer', payload: { sort: mediaState?.sort < 0 ? 1 : -1, selectedData: [], allSelected: false, page: 0, loading: true } });
	};

	return (
		<TableHead>
			<TableRow>
				{([ 0, 1, 3, 4 ].includes(tab) || (tab === 2 && id)) && <TableCell padding='checkbox'>
					<Checkbox
						color='primary'
						checked={mediaState?.selectedData?.length === visibleFolderData?.length}
						onChange={handleSelectAll}
						inputProps={{
							'aria-label' : 'select all desserts'
						}}
					/>
				</TableCell>}
				<TableCell
					style={{ minWidth: 400 }}
				>
					<TableSortLabel
						active
						direction={mediaState?.sort === 1 ? 'asc' : 'desc'}
						onClick={toggleSortByName}
					>
						<div className='subHeadingSM capitalTxt'>
							{language?.fileFolderName}

						</div>
						<Box component='span' sx={visuallyHidden}>
							{'sorted descending'}
						</Box>
					</TableSortLabel>

				</TableCell>
				<TableCell
					align='center'
					padding='normal'
					style={{ minWidth: 280 }}
				/>
			</TableRow>
		</TableHead>
	);
};

export default MediaKitTableHead;
